import type { ApiResponse } from '~/plugins/http/types';
import type { LoginInfo } from '~/stores/user';
import { request } from '@/utils/request';

/**
 * 获取验证码图片
 * @param uuid 唯一标识
 */
export const getVerifyCode = (uuid: string) => {
	return request({
		url: `/sso/getVerifyCodeImg?uuid=${uuid}`,
		method: 'GET',
		responseType: 'blob',
	});
};

/**
 * 用户登录接口
 * @param params 登录参数
 */
export const doLogin = (params: any) => {
	const formData = new FormData();
	formData.append('userName', params.userName);
	formData.append('password', params.password);
	formData.append('validateCode', params.validateCode);
	formData.append('uuid', params.uuid);

	debugger;
	return request<ApiResponse<LoginInfo>>({
		url: '/sso/mallLogin',
		method: 'POST',
		body: formData,
	});
};
